const findWidgetClasses = (element) =>
	element?.closest?.('[data-widget-id]')?.classList?.toString?.() || '';

export default findWidgetClasses;
